<script setup lang="ts">
defineOptions({ name: 'XomDevMicroMarker' });
defineProps<{ tooltip?: boolean | string }>();
</script>

<template>
  <a-tooltip
    v-if="tooltip"
    :title="
      typeof tooltip === 'string' ? tooltip : `开发环境子系统，不记录数据库，仅缓存于开发机本地`
    "
  >
    <a-typography-text type="danger" style="font-size: 1em">
      <code-filled />
    </a-typography-text>
  </a-tooltip>

  <a-typography-text v-else type="danger" style="font-size: 1em">
    <code-filled />
  </a-typography-text>
</template>
